import React from 'react'
import Content from 'blocks.app/content/content'
import translate from 'core/translate'
import { TemplateEditorView } from 'blocks.app/templateEditor'

export const TemplateEditor = () => (
    <Content title={translate('templateEditor')} indentsMod="none" fullHeight noPadding style={{ paddingTop: 0 }}>
        <TemplateEditorView />
    </Content>
)
